// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.22632 2H22.2263V11H2.22632V2ZM8.22827 5.5H6.22437V7.50391H8.22827V5.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.22632 13H22.2263V22H2.22632V13ZM8.22827 16.5H6.22437V18.5039H8.22827V16.5Z"}}]};

const DataFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'data-filled',
    ref,
    icon: element,
  },
));

DataFilledIcon.displayName = 'DataFilledIcon';

export default DataFilledIcon;
